'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requirementDataActions = require('actions/requirementDataActions');

// requirementSets are stored by code
function requirementSets() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _requirementDataActions.REQUIREMENT_DATA_RECEIVED:
            return action.requirementData.requirementSets;
        default:
            return state;
    }
}

exports.default = requirementSets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/requirementSets.js
// module id = 1402
// module chunks = 0